var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuViewContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f1f1;}.b{fill:#7d8dd8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -692)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(60 692)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.5,20H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14.5a2,2,0,0,1,2,2V18A2,2,0,0,1,14.5,20ZM3.749,14a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Zm0-5a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Zm5.5-5a1,1,0,1,0,0,2h3.5a1,1,0,1,0,0-2Z",
    transform: "translate(16.5 20) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(18.001 20) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuViewContract);
export default __webpack_public_path__ + "static/media/icon-menu-view-contract.06f421843646740fc06a7c22abb01a72.svg";
export { ForwardRef as ReactComponent };